import {createTheme, ThemeOptions} from "@mui/material";

/**
 * Material theme options using the graphic charter of the company Fonroche Lighting.
 * @author Alizée Grand
 * @version 1.0
 * @creation 16/03/2022
 * @last_update 16/03/2022
 **/
export const themeOptions: ThemeOptions = {
    palette: {
        mode: "light",
        primary: {
            main: '#ee7f18',
            light: '#f08c2f',
            dark: '#d17015',
            contrastText: '#000000',
        },
        secondary: {
            main: 'rgba(255,255,255,1)',
            light: '#337ea6',
            dark: '#196389',
            contrastText: '#ffffff'
        },
        text: {
            primary: 'rgba(64,71,76,1)',
            secondary: 'rgba(64,71,76,0.75)',
            disabled: 'rgba(64,71,76,0.25)',
        },
        error: {
            main: '#AF1818',
            light: '#FD2626',
            dark: '#7D1212',
            contrastText: '#ffffff'
        },
        warning: {
            main: 'rgb(232,192,33)',
            light: '#FFD21F',
            dark: '#B8991E',
            contrastText: '#000000',
        },
        success: {
            main: '#3aa840',
            light: '#2dd736',
            dark: '#21af28',
            contrastText: '#ffffff',
        },
    },

};

/**
 * Material theme using the graphic charter of the company Fonroche Lighting.
 * @author Alizée Grand
 * @version 1.0
 * @creation 16/03/2022
 * @last_update 16/03/2022
 **/
export const fonrocheTheme = createTheme(themeOptions);
